import React, { useEffect, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Spinners from "components/Common/Spinner";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getAverageByEvaluation } from "store/actions";
import { Row, Col, Card, CardBody, Badge, Button } from "reactstrap";
import { ToastContainer } from "react-toastify";

import { PDFDownloadLink } from "@react-pdf/renderer";

import AverageValidUePDF from "./partials/AverageValidUePDF";
import AverageInvalidUePDF from "./partials/AverageInvalidUePDF";
import StudentTranscriptPDF from "./partials/StudentTranscriptPDF";

const Average = () => {
  document.title = "Moyennes | CinzanEdu";

  const dispatch = useDispatch();
  const { evaluationUuid } = useParams();

  const { averageData, loadingAverage } = useSelector((state) => state.evaluationReducer);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setLoading] = useState(true);

  // Charger la moyenne pour l'évaluation sélectionnée
  useEffect(() => {
    if (evaluationUuid) dispatch(getAverageByEvaluation(evaluationUuid));
  }, [dispatch, evaluationUuid]);

  // Préparer les données pour TableContainer


useEffect(() => {
  if (Array.isArray(averageData)) {
    const rows = [];

    averageData.forEach((student) => {
      // Convertir student.ues (objet) en tableau
      const uesArray = student.ues ? Object.values(student.ues) : [];

      uesArray.forEach((ue) => {
        ue.ecs?.forEach((ec) => {
          rows.push({
            student_id: student.student_id,
            student_number: student.student_number,
            student_name: `${student.first_name} ${student.last_name}` || "—", // sécuriser student_name
            ue_title: ue.ue_title,
            ue_note: parseFloat(ue.ue_note) || 0, // parseFloat pour toFixed
            ue_valid: ue.ue_valid,
            ec_title: ec.ec_title,
            ec_note: parseFloat(ec.ec_note) || 0, // parseFloat pour toFixed
            ec_to_retake: ec.to_retake
          });
        });
      });
    });

    setTableData(rows);
  }
}, [averageData]);

  const columns = [
    { 
        header: "N°Etudiant", 
        accessorKey: "student_number" ,
        enableColumnFilter: false,
        enableSorting: true,
    },
     { 
        header: "Prénom et Nom", 
        accessorKey: "student_name",
        enableColumnFilter: false,
        enableSorting: true,
    },
    { 
        header: "UE", 
        accessorKey: "ue_title",
        enableColumnFilter: false,
        enableSorting: true,
    },
    { 
        header: "Note UE", 
        accessorKey: "ue_note", cell: (props) => props.row.original.ue_note.toFixed(2),
        enableColumnFilter: false,
        enableSorting: true,
    },
    { 
      header: "UE validée", 
      accessorKey: "ue_valid", 
      enableColumnFilter: false,
    enableSorting: true,
      cell: (props) => props.row.original.ue_valid 
        ? <Badge color="success">Validé</Badge> 
        : <Badge color="danger">Ajourné</Badge> 
    },
    { 
        header: "EC", 
        accessorKey: "ec_title",
        enableColumnFilter: false,
        enableSorting: true,
    },
    { 
        header: "Note EC", 
        accessorKey: "ec_note", cell: (props) => props.row.original.ec_note.toFixed(2) ,
        enableColumnFilter: false,
        enableSorting: true,
    },
    { 
      header: "Rattrapage", 
      accessorKey: "ec_to_retake",
      enableColumnFilter: false,
    enableSorting: true, 
      cell: (props) => props.row.original.ec_to_retake 
        ? <Badge color="warning">À reprendre</Badge> 
        : <Badge color="success">Validé</Badge> 
    }
  ];

  const handlePrint = () => {
    window.print();
  };

  // Spinner personnalisé avec setLoading
  if (isLoading || loadingAverage) return <Spinners setLoading={setLoading} />;

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Moyennes" breadcrumbItem="Liste des moyennes" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom d-flex align-items-center">
                <h5 className="mb-0 card-title flex-grow-1">
                    Moyennes de l'évaluation: {averageData && averageData.length > 0 ? averageData[0].evaluation_title : ""}
                </h5>
                <div className="flex-shrink-0">
                    <Button color="primary" className="me-2">
                    <PDFDownloadLink
                        document={<AverageInvalidUePDF data={averageData} />}
                        fileName="moyennes_invalidées.pdf"
                        style={{ color: "#fff", textDecoration: "none" }}
                    >
                        {({ loading }) => (loading ? "Génération..." : "Liste par UE invalidée")}
                    </PDFDownloadLink>
                    </Button>
                    <Button color="primary" className="me-2">
                    <PDFDownloadLink
                        document={<AverageValidUePDF data={averageData} />}
                        fileName="moyennes_validées.pdf"
                        style={{ color: "#fff", textDecoration: "none" }}
                    >
                        {({ loading }) => (loading ? "Génération..." : "Liste par UE validée")}
                    </PDFDownloadLink>
                    </Button>
                    <Button color="primary">
                    <PDFDownloadLink
                        document={<StudentTranscriptPDF data={averageData} />}
                        fileName="relevee_de_notes.pdf"
                        style={{ color: "#fff", textDecoration: "none" }}
                    >
                        {({ loading }) => (loading ? "Génération..." : "Rélévée de note")}
                    </PDFDownloadLink>
                    </Button>
                </div>
                </CardBody>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={tableData || []}
                    isCustomPageSize={true}
                    isGlobalFilter={true}
                    isPagination={true}
                    SearchPlaceholder="Rechercher ..."
                    tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                    theadClass="table-light"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default Average;